import { compose, getContext, branch, renderNothing } from 'recompose';
import PropTypes from 'prop-types';

const withEditability = compose(
  getContext({ readOnly: PropTypes.bool }),
  branch(({ readOnly }) => readOnly, renderNothing)
);

export default withEditability;
